import { useEffect, useState } from "react";
import { FaCaretDown } from "react-icons/fa";
import {
  Button,
  Col,
  Collapse,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import CheckedInput2 from "./CheckedInput2";
import moment from "moment";
const defaultDays = [
  {
    day: "Monday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Tuesday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Wednesday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Thursday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Friday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Saturday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
  {
    day: "Sunday",
    checked: false,
    openTime: new Date().getTime(),
    closeTime: new Date().getTime(),
  },
];
const AvailabililityInput = ({ value, setAvailabilityValue, label, t }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentlySelected, setCurrentlySelected] = useState([]);
  const checkedSelect = (value, item) => {
    let array = [...currentlySelected];
    let index = array?.findIndex((i) => i?.day === item?.day);
    array[index].checked = value;
    console.log("array-===>", array);
    setCurrentlySelected(array);
  };
  const handleTimeZoneChange = (newValue, item, type) => {
    let array = [...currentlySelected];
    let index = array?.findIndex((i) => i?.day === item?.day);
    if (type === "openTime") array[index].openTime = newValue;
    else array[index].closeTime = newValue;
    setCurrentlySelected(array);
  };

  const getTimeStampFromTime = (formatedTime) => {
    if (typeof formatedTime === "number") return formatedTime;
    let date = new Date();
    let split = formatedTime?.split(":");
    date.setHours(split?.[0], split?.[1]);
    return Date.parse(date);
  };

  const isCheckedBefore = (item) => {
    let openTimeStamp = getTimeStampFromTime(item?.openTime);
    let closeTimeStamp = getTimeStampFromTime(item?.closeTime);

    return item?._id ? true : false;
  };

  useEffect(() => {
    if (value && Array.isArray(value)) {
      let array = [...value];
      console.log("Vlauye comming from edit", array);
      let selected = defaultDays?.map((item, at) => {
        let presentItem = array?.find((i) => i?.day === item?.day);
        if (presentItem) {
          return {
            day: presentItem?.day,
            checked: isCheckedBefore(presentItem),
            openTime: presentItem?.openTime,
            closeTime: presentItem?.closeTime,
          };
        } else return item;
      });
      setCurrentlySelected(selected);
    }
  }, [value]);
  const onPressDoneBtn = () => {
    const selectedDays = currentlySelected.filter((item) => item?.checked);
    setAvailabilityValue(selectedDays);
    setModalOpen(false);
  };
  return (
    <div className="normal-input-2">
      <Label className="figma-input-label">{label}</Label>
      <Button
        className="d-flex px-3 text-black align-items-center justify-content-between full-width"
        onClick={() => setModalOpen(true)}
      >
        <div className="d-flex flex-wrap align-items-strech gap-2">
          {value?.length > 0
            ? value?.map((item, index) => (
                <div
                  style={{ background: "#21005d" }}
                  className=" text-white rounded-pill px-3 py-2"
                >
                  {item?.day?.toString()}
                </div>
              ))
            : t("selectAvailability")}
        </div>
        <div className="color-primary-blue">
          <FaCaretDown size={20} />
        </div>
      </Button>
      <Modal
        centered
        isOpen={modalOpen}
        size="md"
        toggle={() => setModalOpen((prev) => !prev)}
      >
        <ModalBody
          className="bg-white px-4"
          style={{ borderRadius: "14.76px" }}
        >
          <h3 className="color-primary-black-7 my-3 f-5 text-center figma-shadowed-black-text">
            {t("availability")}
          </h3>
          <h4 className="f-4 text-center figma-font-md mb-3">
            Please specify the days of the week and hours of availability
          </h4>
          <div>
            {[...currentlySelected]
              ?.filter((i) => i?.checked)
              ?.map((item, at) => (
                <div className="mb-4">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <CheckedInput2
                      iconSize={26}
                      value={item?.checked}
                      setValue={(v) => checkedSelect(v, item)}
                    />
                    <p className="f-5 m-0 baloo-font">{item?.day}</p>
                  </div>
                  <Collapse isOpen={item?.checked}>
                    <Row className=" g-3">
                      <Col md={6}>
                        <p className="mb-1 f-6">From</p>
                        <Input
                          value={item?.openTime}
                          onChange={(e) =>
                            handleTimeZoneChange(
                              e?.target?.value,
                              item,
                              "openTime"
                            )
                          }
                          className="availibility-time-input"
                          type="time"
                        />
                      </Col>
                      <Col md={6}>
                        <p className="mb-1 f-6">To</p>
                        <Input
                          value={item?.closeTime}
                          onChange={(e) =>
                            handleTimeZoneChange(
                              e?.target?.value,
                              item,
                              "closeTime"
                            )
                          }
                          className="availibility-time-input"
                          type="time"
                        />
                      </Col>
                    </Row>
                  </Collapse>
                </div>
              ))}
            <Row className="g-3 mb-4">
              {[...currentlySelected]
                ?.filter((i) => !i?.checked)
                ?.map((item, at) => (
                  <Col md={4}>
                    <div className="d-flex align-items-center gap-2">
                      <CheckedInput2
                        iconSize={26}
                        value={item?.checked}
                        setValue={(v) => checkedSelect(v, item)}
                      />
                      <p className="f-5 m-0 baloo-font">{item?.day}</p>
                    </div>
                  </Col>
                ))}
            </Row>
            <Button
              onClick={onPressDoneBtn}
              className="standard-rounded-btn full-width py-3"
            >
              {t("done")}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};
export default AvailabililityInput;
